export const EntityType = {
  Tag: "tag",

  Stack: "stack",
  Block: "block",
  Fact: "fact",

  Task: "task",

  Asset: "asset",

  Contact: "contact",

  Note: "note",

  Memory: "memory",

  Connection: "connection",
  Document: "document",
} as const;

export type EntityType = (typeof EntityType)[keyof typeof EntityType];
